<template v-slot:item._deleted="{ item }">
  
      <v-chip
        small
        :color="getColor(item._deleted)"
      >
      </v-chip>
  
</template>
<script>

export default {
  name: "activeChip",
  props: ["item"],
  data() {
    return {};
  },
  methods:{
    
    getColor(Status) {
    if (Status === true) return "red";
    else return "green";
    },
  }
};
</script>